/* eslint-disable no-param-reassign */
import OpacityIcon from "@mui/icons-material/Opacity";
import { Fab, Tooltip } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import * as Cesium from "cesium";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.primary.contrastText,
  },
}));

type Props = {
  viewer: Cesium.Viewer;
};

const GlobeTranslucencyButton = ({ viewer }: Props): JSX.Element => {
  const classes = useStyles();
  const [translucent, setTranslucent] = useState(
    viewer.scene.globe.translucency.enabled,
  );
  const { t } = useTranslation("cesium");

  useEffect(() => {
    setTranslucent(viewer.scene.globe.translucency.enabled);
  }, [viewer.scene.globe.translucency.enabled]);

  return translucent ? (
    <Tooltip title={t("globe-translucency-off").toString()}>
      <Fab
        size="small"
        color="primary"
        onClick={() => {
          viewer.scene.globe.translucency.enabled = false;
          viewer.scene.screenSpaceCameraController.enableCollisionDetection =
            true;
          setTranslucent(false);
        }}
      >
        <OpacityIcon className={classes.icon} />
      </Fab>
    </Tooltip>
  ) : (
    <Tooltip title={t("globe-translucency-on").toString()}>
      <Fab
        size="small"
        color="primary"
        onClick={() => {
          viewer.scene.globe.translucency.enabled = true;
          viewer.scene.screenSpaceCameraController.enableCollisionDetection =
            false;
          setTranslucent(true);
        }}
      >
        <OpacityIcon className={classes.icon} />
      </Fab>
    </Tooltip>
  );
};

export default GlobeTranslucencyButton;
